// src/screens/delivery/support/DeliverySupport.jsx
import React, { useState, useEffect, useRef, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaTicketAlt,
  FaChevronDown,
  FaChevronUp,
  FaSearch,
  FaPlus,
  FaEye,
  FaCheckCircle,
  FaHeadset,
  FaPaperPlane,
  FaExclamationCircle,
  FaUser,
  FaEnvelope,
  FaCalendarAlt,
  FaTag,
  FaTimes,
  FaComments,
  FaPaperclip,
  FaMotorcycle,
  FaBoxOpen,
} from "react-icons/fa";
import axios from "axios";
import Button from "../../../components/general/button/Button";
import Pagination from "../../../components/general/pagination/Pagination";
import Swal from "sweetalert2";
import "../../../assets/css/delivery/deliverySupport/DeliverySupport.css";
import DeliveryLayout from "../../../layouts/DeliveryPanelLayout";
import MyContext from "../../../context/MyContext";
import { getEcho } from "../../../components/general/echo/Echo";

/* ── Skeleton ── */
const TableSkeleton = ({ rows = 4, cols = 6 }) => (
  <div className="dsp-skeleton-wrap">
    <div className="dsp-skel-row dsp-skel-row--header">
      {Array(cols)
        .fill(0)
        .map((_, i) => (
          <div key={i} className="dsp-skel dsp-skel--th" />
        ))}
    </div>
    {Array(rows)
      .fill(0)
      .map((_, r) => (
        <div key={r} className="dsp-skel-row">
          {Array(cols)
            .fill(0)
            .map((_, c) => (
              <div key={c} className="dsp-skel dsp-skel--td" />
            ))}
        </div>
      ))}
  </div>
);

const DeliverySupport = () => {
  // ── FIX: authToken pehle destructure nahi ho raha tha, is wajah se
  // Echo authenticate hi nahi ho pa raha tha ──
  const { baseUrl, authToken, loggedInDeliveryMan } = useContext(MyContext);

  /* ── Form States ── */
  const [subject, setSubject] = useState("");
  const [type, setType] = useState("");
  const [description, setDescription] = useState("");
  const [selectedOrder, setSelectedOrder] = useState("");
  const [completedOrders, setCompletedOrders] = useState([]);
  /* ── Data States ── */
  const [receivedTickets, setReceivedTickets] = useState([]);
  const [myTickets, setMyTickets] = useState([]);
  const [recLoading, setRecLoading] = useState(true);
  const [myLoading, setMyLoading] = useState(true);

  /* ── Received Table Filters ── */
  const [recSearch, setRecSearch] = useState("");
  const [recStatus, setRecStatus] = useState("all");
  const [recPage, setRecPage] = useState(1);
  const [recPerPage, setRecPerPage] = useState(5);

  /* ── My Tickets Filters ── */
  const [mySearch, setMySearch] = useState("");
  const [myStatus, setMyStatus] = useState("all");
  const [myPage, setMyPage] = useState(1);
  const [myPerPage, setMyPerPage] = useState(5);

  /* ── FAQ ── */
  const [openFaq, setOpenFaq] = useState(null);

  // Resolve Ticket modal — teacher ka kaha hua note field: deliveryman
  // "resolved" mark karte waqt likhta hai kis ke haq mein resolve hua
  const [showResolveModal, setShowResolveModal] = useState(false);
  const [resolveTicketId, setResolveTicketId] = useState(null);
  const [resolutionNote, setResolutionNote] = useState("");
  const [refundDue, setRefundDue] = useState(false);

  const openResolveModal = (ticketId) => {
    setResolveTicketId(ticketId);
    setResolutionNote("");
    setRefundDue(false);
    setShowResolveModal(true);
  };

  const submitResolveTicket = () => {
    if (!resolutionNote.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Note required",
        text: "Please add a note explaining who the dispute was resolved in favor of.",
      });
      return;
    }
    updateTicketStatus(resolveTicketId, "resolved", resolutionNote, refundDue);
    setShowResolveModal(false);
  };
  const [faqs, setFaqs] = useState([]);

  /* ── Received Ticket Modal ── */
  const [showReceivedModal, setShowReceivedModal] = useState(false);
  const [selectedReceivedTicket, setSelectedReceivedTicket] = useState(null);
  const [recChatMessage, setRecChatMessage] = useState("");
  const [recAttachedFile, setRecAttachedFile] = useState(null);
  const [recConversationMessages, setRecConversationMessages] = useState([]);
  const [recConversationId, setRecConversationId] = useState(null);
  const recFileInputRef = useRef(null);
  const recMessagesEndRef = useRef(null);

  /* ── My Ticket Modal ── */
  const [showMyTicketModal, setShowMyTicketModal] = useState(false);
  const [selectedMyTicket, setSelectedMyTicket] = useState(null);
  const [myChatMessage, setMyChatMessage] = useState("");
  const [myAttachedFile, setMyAttachedFile] = useState(null);
  const [myConversationMessages, setMyConversationMessages] = useState([]);
  const [myConversationId, setMyConversationId] = useState(null);
  const myFileInputRef = useRef(null);
  const myMessagesEndRef = useRef(null);

  /* ── Auto Scroll ── */
  useEffect(() => {
    recMessagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [recConversationMessages]);
  useEffect(() => {
    myMessagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [myConversationMessages]);

  /* ══════════════════════════════════════════
     API CALLS
  ══════════════════════════════════════════ */
  const getCompletedOrders = () => {
    axios
      .get(`${baseUrl}/delivery/help/getCompletedOrders`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data.success) {
          setCompletedOrders(res.data.orders);
        }
      })
      .catch((err) => console.log(err));
  };

  const addTicket = () => {
    const formdata = new FormData();
    formdata.append("subject", subject);
    formdata.append("type", type);
    formdata.append("description", description);
    formdata.append("kmorder_id", selectedOrder);

    axios
      .post(`${baseUrl}/delivery/help/addTicket`, formdata, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.hasOwnProperty("error")) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Support ticket added successfully!",
          });
          setSubject("");
          setType("");
          setDescription("");
          setSelectedOrder("");
          viewAllMyTickets();
        }
      })
      .catch(() =>
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to add support ticket",
        }),
      );
  };

  const viewAllMyTickets = () => {
    setMyLoading(true);

    axios
      .get(`${baseUrl}/delivery/help/viewAllMyTickets`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (response.data.hasOwnProperty("error")) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        } else {
          setMyTickets(response.data.ticket);
        }
        setMyLoading(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load tickets.",
        });
        setMyLoading(false);
      });
  };

  const viewAllReceivedTickets = () => {
    setRecLoading(true);
    axios
      .get(`${baseUrl}/delivery/help/viewAllReceivedTickets`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (response.data.hasOwnProperty("error")) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        } else {
          setReceivedTickets(response.data.ticket);
        }
        setRecLoading(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load customer tickets.",
        });
        setRecLoading(false);
      });
  };

  const updateTicketStatus = (ticketId, newStatus, note, isRefundDue) => {
    const formData = new FormData();
    formData.append("id", ticketId);
    formData.append("status", newStatus);
    if (newStatus === "resolved") {
      formData.append("resolution_note", note || "");
      formData.append("refund_due", isRefundDue ? 1 : 0);
    }
    axios
      .post(`${baseUrl}/delivery/help/updateTicketStatus`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Status updated!",
          });
          viewAllReceivedTickets();
          if (selectedReceivedTicket?.id === ticketId) {
            setSelectedReceivedTicket((prev) => ({
              ...prev,
              status: newStatus,
              resolution_note: note,
              refund_due: isRefundDue ? 1 : 0,
            }));
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to update status.",
          });
        }
      })
      .catch(() =>
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update status.",
        }),
      );
  };

  const fetchChatForReceivedTicket = (ticket) => {
    const fd = new FormData();
    fd.append("kmhelpandsupport_id", ticket.id);
    axios
      .post(`${baseUrl}/delivery/chats/fetchChatForHelp`, fd, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data.success) {
          setRecConversationMessages(res.data.chats);
          setRecConversationId(res.data.conversation_id);
        } else {
          setRecConversationMessages([]);
        }
      })
      .catch((err) => console.log(err));
  };

  const fetchChatForMyTicket = (ticket) => {
    const fd = new FormData();
    fd.append("kmhelpandsupport_id", ticket.id);
    axios
      .post(`${baseUrl}/delivery/chats/fetchChatForHelp`, fd, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data.success) {
          setMyConversationMessages(res.data.chats);
          setMyConversationId(res.data.conversation_id);
        } else {
          setMyConversationMessages([]);
        }
      })
      .catch((err) => console.log(err));
  };

  const sendReceivedMessage = () => {
    if (!recChatMessage.trim() && !recAttachedFile) return;
    if (!recConversationId) return;
    const fd = new FormData();
    fd.append("kmconversation_id", recConversationId);
    fd.append("send_by", "deliveryman");
    fd.append("message", recChatMessage);
    fd.append("image", recAttachedFile);
    axios
      .post(`${baseUrl}/delivery/chat/sendMessage`, fd, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (!res.data.hasOwnProperty("error")) {
          setRecChatMessage("");
          setRecAttachedFile(null);
          if (recFileInputRef.current) recFileInputRef.current.value = "";
          fetchChatForReceivedTicket(selectedReceivedTicket);
        }
      });
  };

  const sendMyMessage = () => {
    if (!myChatMessage.trim() && !myAttachedFile) return;
    if (!myConversationId) return;
    const fd = new FormData();
    fd.append("kmconversation_id", myConversationId);
    fd.append("send_by", "delivery");
    fd.append("message", myChatMessage);
    fd.append("image", myAttachedFile);
    axios
      .post(`${baseUrl}/delivery/chat/sendMessage`, fd, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (!res.data.hasOwnProperty("error")) {
          setMyChatMessage("");
          setMyAttachedFile(null);
          if (myFileInputRef.current) myFileInputRef.current.value = "";
          fetchChatForMyTicket(selectedMyTicket);
        }
      });
  };
  const Deliveryfaqs = () => {
    axios
      .get(`${baseUrl}/delivery/faq/viewAllFaqs`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data.success) {
          setFaqs(res.data.faqs);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /* ── useEffects ── */

  useEffect(() => {
    const deliveryman = JSON.parse(localStorage.getItem("loggedInDeliveryMan"));

    if (deliveryman) {
      viewAllMyTickets(deliveryman.id);
      getCompletedOrders(deliveryman.id);
    }
  }, []);

  useEffect(() => {
    viewAllReceivedTickets();
  }, []);
  useEffect(() => {
    if (authToken) {
      Deliveryfaqs();
    }
  }, [authToken]);
  // ── real-time — received ticket ka conversation khula ho to naya
  // message aate hi list mein append kar do ──
  useEffect(() => {
    if (!authToken || !recConversationId) return;

    const echo = getEcho(baseUrl, authToken);
    if (!echo) return;

    const channelName = `conversation.${recConversationId}`;
    const channel = echo.private(channelName);

    channel.listen(".new-message", (e) => {
      const incoming = e.message;
      setRecConversationMessages((prev) => {
        if (prev.some((m) => m.id === incoming.id)) return prev;
        return [...prev, incoming];
      });
    });

    return () => {
      echo.leave(channelName);
    };
  }, [authToken, recConversationId]);

  // ── real-time — my ticket ka conversation khula ho to naya
  // message aate hi list mein append kar do ──
  useEffect(() => {
    if (!authToken || !myConversationId) return;

    const echo = getEcho(baseUrl, authToken);
    if (!echo) return;

    const channelName = `conversation.${myConversationId}`;
    const channel = echo.private(channelName);

    channel.listen(".new-message", (e) => {
      const incoming = e.message;
      setMyConversationMessages((prev) => {
        if (prev.some((m) => m.id === incoming.id)) return prev;
        return [...prev, incoming];
      });
    });

    return () => {
      echo.leave(channelName);
    };
  }, [authToken, myConversationId]);

  /* ── Helpers ── */
  const formatTime = (datetime) => {
    if (!datetime) return "";
    return new Date(datetime).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const statusClass = (s) =>
    ({
      open: "dsp-status--open",
      in_progress: "dsp-status--pending",
      resolved: "dsp-status--resolved",
      closed: "dsp-status--closed",
    })[s] || "dsp-status--open";

  const getStatusLabel = (s) =>
    ({
      open: "Open",
      in_progress: "In Progress",
      resolved: "Resolved",
      closed: "Closed",
    })[s] || s;

  const getStatusOptions = (currentStatus) => {
    switch (currentStatus) {
      case "open":
        return ["in_progress", "resolved", "closed"];
      case "in_progress":
        return ["resolved", "closed"];
      case "resolved":
        return ["closed"];
      default:
        return [];
    }
  };

  /* ── Action Dropdowns ── */
  const ReceivedTicketActionDropdown = ({ ticket, onView }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
      const onDocumentMouseDown = (e) => {
        if (ref.current && !ref.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("mousedown", onDocumentMouseDown);
      return () =>
        document.removeEventListener("mousedown", onDocumentMouseDown);
    }, []);
    const statusOptions = getStatusOptions(ticket.status);
    return (
      <div className="dsp-action-wrapper" ref={ref}>
        <button
          className="dsp-action-toggle"
          onClick={() => setOpen((p) => !p)}
        >
          <span className="dsp-action-dot" />
          <span className="dsp-action-dot" />
          <span className="dsp-action-dot" />
        </button>
        {open && (
          <div className="dsp-action-dropdown">
            <button
              className="dsp-action-item"
              onClick={() => {
                onView(ticket);
                setOpen(false);
              }}
            >
              <FaEye className="dsp-action-icon" /> View Details
            </button>
            {statusOptions.map((opt) => (
              <button
                key={opt}
                className="dsp-action-item"
                onClick={() => {
                  if (opt === "resolved") {
                    openResolveModal(ticket.id);
                  } else {
                    updateTicketStatus(ticket.id, opt);
                  }
                  setOpen(false);
                }}
              >
                <FaCheckCircle className="dsp-action-icon" /> Mark as
                {getStatusLabel(opt)}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  };

  const MyTicketActionDropdown = ({ ticket, onView }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
      const onDocumentMouseDown = (e) => {
        if (ref.current && !ref.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("mousedown", onDocumentMouseDown);
      return () =>
        document.removeEventListener("mousedown", onDocumentMouseDown);
    }, []);
    return (
      <div className="dsp-action-wrapper" ref={ref}>
        <button
          className="dsp-action-toggle"
          onClick={() => setOpen((p) => !p)}
        >
          <span className="dsp-action-dot" />
          <span className="dsp-action-dot" />
          <span className="dsp-action-dot" />
        </button>
        {open && (
          <div className="dsp-action-dropdown">
            <button
              className="dsp-action-item"
              onClick={() => {
                onView(ticket);
                setOpen(false);
              }}
            >
              <FaEye className="dsp-action-icon" /> View Details
            </button>
          </div>
        )}
      </div>
    );
  };

  /* ── Filter & Paginate ── */
  const filterTickets = (list, search, status) =>
    (list || []).filter(
      (t) =>
        (t.subject?.toLowerCase().includes(search.toLowerCase()) ||
          String(t.id)?.includes(search)) &&
        (status === "all" || t.status === status),
    );

  const paginate = (list, page, perPage) =>
    list.slice((page - 1) * perPage, page * perPage);

  const filteredRec = filterTickets(receivedTickets, recSearch, recStatus);
  const filteredMy = filterTickets(myTickets, mySearch, myStatus);
  const pageRec = paginate(filteredRec, recPage, recPerPage);
  const pageMy = paginate(filteredMy, myPage, myPerPage);

  /* ══════════════════════════════════════════
     RENDER
  ══════════════════════════════════════════ */
  return (
    <DeliveryLayout>
      <div className="dsp-container">
        <Container fluid>
          {/* ── Page Header ── */}
          <div className="dsp-header">
            <h1>Help & Support</h1>
            <p>
              Manage customer delivery complaints and get help from our team
            </p>
          </div>

          {/* ══════════════════════════════════════════
              TABLE 1 — Received Tickets (from customers)
          ══════════════════════════════════════════ */}
          <div className="dsp-section">
            <div className="dsp-section__header">
              <div className="dsp-section__title">
                <FaExclamationCircle className="dsp-section__icon dsp-section__icon--red" />
                <h4>Customer Complaints</h4>
                <span className="dsp-section__count">
                  {receivedTickets.length}
                </span>
              </div>
              <div className="dsp-toolbar">
                <div className="dsp-search">
                  <FaSearch />
                  <input
                    type="text"
                    placeholder="Search complaints..."
                    value={recSearch}
                    onChange={(e) => {
                      setRecSearch(e.target.value);
                      setRecPage(1);
                    }}
                  />
                </div>
                <select
                  className="dsp-filter"
                  value={recStatus}
                  onChange={(e) => {
                    setRecStatus(e.target.value);
                    setRecPage(1);
                  }}
                >
                  <option value="all">All Status</option>
                  <option value="open">Open</option>
                  <option value="in_progress">In Progress</option>
                  <option value="resolved">Resolved</option>
                  <option value="closed">Closed</option>
                </select>
              </div>
            </div>

            {recLoading ? (
              <TableSkeleton rows={4} cols={7} />
            ) : (
              <div className="dsp-table-wrap">
                <table className="dsp-table">
                  <thead>
                    <tr>
                      <th>Ticket ID</th>
                      <th>Customer</th>
                      <th>Order ID</th>
                      <th>Subject</th>
                      <th>Status</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pageRec.length === 0 ? (
                      <tr>
                        <td colSpan={7} className="dsp-empty">
                          No complaints found
                        </td>
                      </tr>
                    ) : (
                      pageRec.map((ticket) => (
                        <tr key={ticket.id}>
                          <td className="dsp-ticket-id">#{ticket.id}</td>
                          <td>
                            <div className="dsp-customer">
                              <strong>
                                {ticket.kmcustomer?.name || "N/A"}
                              </strong>
                              <small>{ticket.kmcustomer?.email || ""}</small>
                            </div>
                          </td>
                          <td className="dsp-order-id">
                            #{ticket.kmorder?.id || "N/A"}
                          </td>
                          <td className="dsp-subject">{ticket.subject}</td>
                          <td>
                            <span
                              className={`dsp-status ${statusClass(ticket.status)}`}
                            >
                              {getStatusLabel(ticket.status)}
                            </span>
                          </td>
                          <td className="dsp-date">
                            {ticket.created_at?.split("T")[0]}
                          </td>
                          <td>
                            <ReceivedTicketActionDropdown
                              ticket={ticket}
                              onView={(t) => {
                                setSelectedReceivedTicket(t);
                                setRecChatMessage("");
                                setRecAttachedFile(null);
                                setShowReceivedModal(true);
                                fetchChatForReceivedTicket(t);
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              totalItems={filteredRec.length}
              itemsPerPage={recPerPage}
              currentPage={recPage}
              onPageChange={setRecPage}
              onItemsPerPageChange={(n) => {
                setRecPerPage(n);
                setRecPage(1);
              }}
            />
          </div>

          {/* ══════════════════════════════════════════
              TABLE 2 — My Tickets (raised by delivery boy)
          ══════════════════════════════════════════ */}
          <div className="dsp-section">
            <div className="dsp-section__header">
              <div className="dsp-section__title">
                <FaTicketAlt className="dsp-section__icon dsp-section__icon--blue" />
                <h4>My Tickets</h4>
                <span className="dsp-section__count">{myTickets.length}</span>
              </div>
              <div className="dsp-toolbar">
                <div className="dsp-search">
                  <FaSearch />
                  <input
                    type="text"
                    placeholder="Search my tickets..."
                    value={mySearch}
                    onChange={(e) => {
                      setMySearch(e.target.value);
                      setMyPage(1);
                    }}
                  />
                </div>
                <select
                  className="dsp-filter"
                  value={myStatus}
                  onChange={(e) => {
                    setMyStatus(e.target.value);
                    setMyPage(1);
                  }}
                >
                  <option value="all">All Status</option>
                  <option value="open">Open</option>
                  <option value="in_progress">In Progress</option>
                  <option value="resolved">Resolved</option>
                  <option value="closed">Closed</option>
                </select>
              </div>
            </div>

            {myLoading ? (
              <TableSkeleton rows={3} cols={6} />
            ) : (
              <div className="dsp-table-wrap">
                <table className="dsp-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Subject</th>
                      <th>Type</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pageMy.length === 0 ? (
                      <tr>
                        <td colSpan={6} className="dsp-empty">
                          No tickets found
                        </td>
                      </tr>
                    ) : (
                      pageMy.map((ticket) => (
                        <tr key={ticket.id}>
                          <td className="dsp-ticket-id">#{ticket.id}</td>
                          <td className="dsp-subject">{ticket.subject}</td>
                          <td className="dsp-type">{ticket.type}</td>
                          <td className="dsp-date">
                            {ticket.created_at?.split("T")[0]}
                          </td>
                          <td>
                            <span
                              className={`dsp-status ${statusClass(ticket.status)}`}
                            >
                              {getStatusLabel(ticket.status)}
                            </span>
                          </td>
                          <td>
                            <MyTicketActionDropdown
                              ticket={ticket}
                              onView={(t) => {
                                setSelectedMyTicket(t);
                                setMyChatMessage("");
                                setMyAttachedFile(null);
                                setShowMyTicketModal(true);
                                fetchChatForMyTicket(t);
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              totalItems={filteredMy.length}
              itemsPerPage={myPerPage}
              currentPage={myPage}
              onPageChange={setMyPage}
              onItemsPerPageChange={(n) => {
                setMyPerPage(n);
                setMyPage(1);
              }}
            />
          </div>

          {/* ══════════════════════════════════════════
              FAQ + Create Ticket
          ══════════════════════════════════════════ */}
          <Row className="g-4">
            {/* FAQ */}
            <Col lg={6}>
              <div className="dsp-section dsp-section--faq">
                <div className="dsp-section__header">
                  <div className="dsp-section__title">
                    <FaHeadset className="dsp-section__icon dsp-section__icon--green" />
                    <h4>Frequently Asked Questions</h4>
                  </div>
                </div>
                <div className="dsp-faq-list">
                  {faqs.map((faq, i) => (
                    <div key={i} className="dsp-faq-item">
                      <div
                        className="dsp-faq-question"
                        onClick={() => setOpenFaq(openFaq === i ? null : i)}
                      >
                        <span>{faq.question}</span>
                        {openFaq === i ? <FaChevronUp /> : <FaChevronDown />}
                      </div>
                      {openFaq === i && (
                        <div className="dsp-faq-answer">{faq.answer}</div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </Col>

            {/* Create Ticket */}
            <Col lg={6}>
              <div className="dsp-section dsp-section--form">
                <div className="dsp-section__header">
                  <div className="dsp-section__title">
                    <FaPlus className="dsp-section__icon dsp-section__icon--blue" />
                    <h4>Create Support Ticket</h4>
                  </div>
                </div>
                <div className="dsp-create-form">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (!selectedOrder || !subject || !type || !description) {
                        Swal.fire({
                          icon: "error",
                          title: "Error",
                          text: "Please fill all fields.",
                        });
                        return;
                      }
                      const db = JSON.parse(
                        localStorage.getItem("loggedInDeliveryMan"),
                      );
                      if (!db) {
                        Swal.fire({
                          icon: "error",
                          title: "Error",
                          text: "Please login again.",
                        });
                        return;
                      }
                      addTicket(db.id);
                    }}
                  >
                    <div className="dsp-form-group">
                      <label>Select Order *</label>

                      <select
                        value={selectedOrder}
                        onChange={(e) => setSelectedOrder(e.target.value)}
                      >
                        <option value="">Select Order</option>

                        {completedOrders.map((order) => (
                          <option key={order.id} value={order.id}>
                            Order #{order.id}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="dsp-form-group">
                      <label>Subject *</label>
                      <input
                        type="text"
                        placeholder="Enter ticket subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </div>
                    <div className="dsp-form-group">
                      <label>Type *</label>
                      <select
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                      >
                        <option value="">Select type</option>
                        <option value="Payment">Payment</option>
                        <option value="Delivery Issue">Delivery Issue</option>
                        <option value="App Problem">App Problem</option>
                        <option value="Account">Account</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div className="dsp-form-group">
                      <label>Description *</label>
                      <textarea
                        rows="5"
                        placeholder="Describe your issue in detail..."
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                    <Button
                      type="submit"
                      variant="primary"
                      fullWidth
                      icon={<FaPaperPlane size={14} />}
                    >
                      Submit Ticket
                    </Button>
                  </form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ══════════════════════════════════════════
          MODAL — Received Ticket Detail
      ══════════════════════════════════════════ */}
      {showReceivedModal && selectedReceivedTicket && (
        <div
          className="dsp-modal-overlay"
          onClick={() => setShowReceivedModal(false)}
        >
          <div className="dsp-modal" onClick={(e) => e.stopPropagation()}>
            {/* Modal Header */}
            <div className="dsp-modal__header">
              <div>
                <h3 className="dsp-modal__title">Customer Complaint Details</h3>
                <p className="dsp-modal__subtitle">
                  Ticket #{selectedReceivedTicket.id}
                </p>
              </div>
              <button
                className="dsp-modal__close"
                onClick={() => setShowReceivedModal(false)}
              >
                <FaTimes size={16} />
              </button>
            </div>

            {/* Modal Body */}
            <div className="dsp-modal__body">
              <Row className="g-4">
                {/* Left — Info */}
                <Col xs={12} md={4}>
                  <div className="dsp-modal-info-card">
                    <h5>Ticket Information</h5>
                    <div className="dsp-modal-info-item">
                      <FaTag />
                      <div>
                        <label>Subject</label>
                        <p>{selectedReceivedTicket.subject}</p>
                      </div>
                    </div>
                    <div className="dsp-modal-info-item">
                      <FaCalendarAlt />
                      <div>
                        <label>Created</label>
                        <p>
                          {new Date(
                            selectedReceivedTicket.created_at,
                          ).toLocaleString()}
                        </p>
                      </div>
                    </div>
                    <div className="dsp-modal-info-item">
                      <FaUser />
                      <div>
                        <label>Customer</label>
                        <p>
                          {selectedReceivedTicket.kmcustomer?.name || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="dsp-modal-info-item">
                      <FaEnvelope />
                      <div>
                        <label>Email</label>
                        <p>
                          {selectedReceivedTicket.kmcustomer?.email || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="dsp-modal-info-item">
                      <FaBoxOpen />
                      <div>
                        <label>Order ID</label>
                        <p className="dsp-order-id">
                          #{selectedReceivedTicket.kmorder?.id || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="dsp-modal-status-card">
                    <h5>Status</h5>
                    <span
                      className={`dsp-status ${statusClass(selectedReceivedTicket.status)}`}
                    >
                      {getStatusLabel(selectedReceivedTicket.status)}
                    </span>
                  </div>
                </Col>

                {/* Right — Chat */}
                <Col xs={12} md={8}>
                  <div className="dsp-modal-chat">
                    <h5 className="dsp-modal-chat__title">
                      <FaComments /> Conversation
                    </h5>
                    <div className="dsp-modal-chat__subject">
                      <strong>Subject:</strong> {selectedReceivedTicket.subject}
                    </div>
                    <div className="dsp-modal-chat__messages">
                      {recConversationMessages?.map((msg) => (
                        <div
                          key={msg.id}
                          className={`dsp-bubble ${msg.send_by === "delivery" ? "dsp-bubble--delivery" : "dsp-bubble--customer"}`}
                        >
                          <div className="dsp-bubble__sender">
                            {msg.send_by === "delivery"
                              ? "You"
                              : selectedReceivedTicket.kmcustomer?.name ||
                                "Customer"}
                          </div>
                          {msg.image && (
                            <img
                              src={`${baseUrl}/storage/${msg.image}`}
                              alt="attachment"
                              style={{
                                maxWidth: "200px",
                                borderRadius: "8px",
                                marginBottom: "4px",
                              }}
                            />
                          )}
                          {msg.message && (
                            <p className="dsp-bubble__text">{msg.message}</p>
                          )}
                          <span className="dsp-bubble__time">
                            {formatTime(msg.created_at)}
                          </span>
                        </div>
                      ))}
                      <div ref={recMessagesEndRef} />
                    </div>

                    {selectedReceivedTicket.status !== "resolved" &&
                    selectedReceivedTicket.status !== "closed" ? (
                      <div className="dsp-modal-chat__input-area">
                        {recAttachedFile && (
                          <div className="dsp-attached-files">
                            <div className="dsp-attached-file">
                              <FaPaperclip />
                              <span>{recAttachedFile.name}</span>
                              <button
                                onClick={() => {
                                  setRecAttachedFile(null);
                                  if (recFileInputRef.current)
                                    recFileInputRef.current.value = "";
                                }}
                              >
                                <FaTimes />
                              </button>
                            </div>
                          </div>
                        )}
                        <div className="dsp-modal-chat__input">
                          <input
                            type="file"
                            ref={recFileInputRef}
                            style={{ display: "none" }}
                            onChange={(e) =>
                              setRecAttachedFile(e.target.files[0] || null)
                            }
                            accept="image/*,.pdf,.doc,.docx"
                          />
                          <label
                            className="dsp-attach-btn"
                            onClick={() => recFileInputRef.current.click()}
                          >
                            <FaPaperclip />
                          </label>
                          <input
                            type="text"
                            placeholder="Type your message..."
                            value={recChatMessage}
                            onChange={(e) => setRecChatMessage(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                sendReceivedMessage();
                              }
                            }}
                          />
                          <button
                            className="dsp-modal-chat__send"
                            onClick={sendReceivedMessage}
                            disabled={
                              !recChatMessage.trim() && !recAttachedFile
                            }
                          >
                            <FaPaperPlane />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="dsp-chat-closed">
                        <FaCheckCircle /> Ticket{" "}
                        {selectedReceivedTicket.status === "resolved"
                          ? "Resolved"
                          : "Closed"}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>

            {/* Modal Footer */}
            <div className="dsp-modal__footer">
              <Button
                variant="secondary"
                onClick={() => setShowReceivedModal(false)}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════
          MODAL — My Ticket Detail
      ══════════════════════════════════════════ */}
      {showMyTicketModal && selectedMyTicket && (
        <div
          className="dsp-modal-overlay"
          onClick={() => setShowMyTicketModal(false)}
        >
          <div className="dsp-modal" onClick={(e) => e.stopPropagation()}>
            <div className="dsp-modal__header">
              <div>
                <h3 className="dsp-modal__title">My Ticket Details</h3>
                <p className="dsp-modal__subtitle">
                  Ticket #{selectedMyTicket.id}
                </p>
              </div>
              <button
                className="dsp-modal__close"
                onClick={() => setShowMyTicketModal(false)}
              >
                <FaTimes size={16} />
              </button>
            </div>

            <div className="dsp-modal__body">
              <Row className="g-4">
                <Col xs={12} md={4}>
                  <div className="dsp-modal-info-card">
                    <h5>Ticket Information</h5>
                    <div className="dsp-modal-info-item">
                      <FaTicketAlt />
                      <div>
                        <label>Subject</label>
                        <p>{selectedMyTicket.subject}</p>
                      </div>
                    </div>
                    <div className="dsp-modal-info-item">
                      <FaCalendarAlt />
                      <div>
                        <label>Created</label>
                        <p>
                          {new Date(
                            selectedMyTicket.created_at,
                          ).toLocaleString()}
                        </p>
                      </div>
                    </div>
                    <div className="dsp-modal-info-item">
                      <FaTag />
                      <div>
                        <label>Type</label>
                        <p>{selectedMyTicket.type}</p>
                      </div>
                    </div>
                    <div className="dsp-modal-info-item">
                      <FaComments />
                      <div>
                        <label>Description</label>
                        <p>{selectedMyTicket.description}</p>
                      </div>
                    </div>
                  </div>
                  <div className="dsp-modal-status-card">
                    <h5>Status</h5>
                    <span
                      className={`dsp-status ${statusClass(selectedMyTicket.status)}`}
                    >
                      {getStatusLabel(selectedMyTicket.status)}
                    </span>
                  </div>
                </Col>

                <Col xs={12} md={8}>
                  <div className="dsp-modal-chat">
                    <h5 className="dsp-modal-chat__title">
                      <FaComments /> Conversation
                    </h5>
                    <div className="dsp-modal-chat__subject">
                      <strong>Type:</strong> {selectedMyTicket.type}
                    </div>
                    <div className="dsp-modal-chat__messages">
                      {myConversationMessages?.map((msg) => (
                        <div
                          key={msg.id}
                          className={`dsp-bubble ${msg.send_by === "delivery" ? "dsp-bubble--delivery" : "dsp-bubble--admin"}`}
                        >
                          <div className="dsp-bubble__sender">
                            {msg.send_by === "delivery" ? "You" : "Admin"}
                          </div>
                          {msg.image && (
                            <img
                              src={`${baseUrl}/storage/${msg.image}`}
                              alt="attachment"
                              style={{
                                maxWidth: "200px",
                                borderRadius: "8px",
                                marginBottom: "4px",
                              }}
                            />
                          )}
                          {msg.message && (
                            <p className="dsp-bubble__text">{msg.message}</p>
                          )}
                          <span className="dsp-bubble__time">
                            {formatTime(msg.created_at)}
                          </span>
                        </div>
                      ))}
                      <div ref={myMessagesEndRef} />
                    </div>

                    {selectedMyTicket.status !== "resolved" &&
                    selectedMyTicket.status !== "closed" ? (
                      <div className="dsp-modal-chat__input-area">
                        {myAttachedFile && (
                          <div className="dsp-attached-files">
                            <div className="dsp-attached-file">
                              <FaPaperclip />
                              <span>{myAttachedFile.name}</span>
                              <button
                                onClick={() => {
                                  setMyAttachedFile(null);
                                  if (myFileInputRef.current)
                                    myFileInputRef.current.value = "";
                                }}
                              >
                                <FaTimes />
                              </button>
                            </div>
                          </div>
                        )}
                        <div className="dsp-modal-chat__input">
                          <input
                            type="file"
                            ref={myFileInputRef}
                            style={{ display: "none" }}
                            onChange={(e) =>
                              setMyAttachedFile(e.target.files[0] || null)
                            }
                            accept="image/*,.pdf,.doc,.docx"
                          />
                          <label
                            className="dsp-attach-btn"
                            onClick={() => myFileInputRef.current.click()}
                          >
                            <FaPaperclip />
                          </label>
                          <input
                            type="text"
                            placeholder="Type your message..."
                            value={myChatMessage}
                            onChange={(e) => setMyChatMessage(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                sendMyMessage();
                              }
                            }}
                          />
                          <button
                            className="dsp-modal-chat__send"
                            onClick={sendMyMessage}
                            disabled={!myChatMessage.trim() && !myAttachedFile}
                          >
                            <FaPaperPlane />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="dsp-chat-closed">
                        <FaCheckCircle /> Ticket{" "}
                        {selectedMyTicket.status === "resolved"
                          ? "Resolved"
                          : "Closed"}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>

            <div className="dsp-modal__footer">
              <Button
                variant="secondary"
                onClick={() => setShowMyTicketModal(false)}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Resolve Ticket Modal — note + refund-due choice */}
      {showResolveModal && (
        <div
          className="dsp-modal-overlay"
          onClick={() => setShowResolveModal(false)}
        >
          <div className="dsp-modal" onClick={(e) => e.stopPropagation()}>
            <div className="dsp-modal__header">
              <h3>Resolve Ticket</h3>
              <button onClick={() => setShowResolveModal(false)}>
                <FaTimes />
              </button>
            </div>
            <div style={{ padding: "16px" }}>
              <label>Resolution note (who is this resolved in favor of?)</label>
              <textarea
                className="form-control"
                rows={4}
                placeholder="e.g. Deliveryman was at fault, package was damaged — refund is due."
                value={resolutionNote}
                onChange={(e) => setResolutionNote(e.target.value)}
              />
              <div style={{ marginTop: "12px" }}>
                <label>
                  <input
                    type="checkbox"
                    checked={refundDue}
                    onChange={(e) => setRefundDue(e.target.checked)}
                    style={{ marginRight: "8px" }}
                  />
                  Customer's refund is due (forward to Admin automatically)
                </label>
              </div>
            </div>
            <div className="dsp-modal__footer">
              <Button
                variant="secondary"
                onClick={() => setShowResolveModal(false)}
              >
                Cancel
              </Button>
              <Button variant="success" onClick={submitResolveTicket}>
                Confirm Resolve
              </Button>
            </div>
          </div>
        </div>
      )}
    </DeliveryLayout>
  );
};

export default DeliverySupport;
